import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	projectSettingsTitle: {
		id: 'platform.ui.breadcrumbs.common-breadcrumbs.project-settings.project-settings-title',
		defaultMessage: 'Project settings',
		description: 'Title of the breadcrumb that navigates to project settings page',
	},
});
